import { createStore } from 'vuex'
import DetailApp from '@/DetailApp/store';

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
	modules: {
		DetailApp
	},
})
